export default function ArrBtn() {
  return (
    <span className="arr-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.79"
        height="11.79"
        viewBox="0 0 11.79 11.79"
      >
        <path
          id="패스_7305"
          data-name="패스_7305"
          d="M6.337,0V6.337H0"
          transform="translate(1.414 5.895) rotate(-45)"
          fill="#302d2c"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
      </svg>
    </span>
  );
}
